import config from 'config';
import { cdnTemplate, jadeLocals } from 'cdnPreprocessor';
import WebStoragePolyfill from '../../data-providers/webstorage-polyfill';

import Analytics from '../../analytics';

let isUpsell = (scope) => (typeof scope.product != 'undefined' && typeof scope.upsellId != 'undefined' && typeof scope.orderId != 'undefined');

export default [
  '$window', '$timeout', 'CartService', 'ErrorHandler',
  function paypalPayment($window, $timeout, cart, errorHandler, analytics = new Analytics) {
    let checkoutFnInProgress = false;
    let storage = new WebStoragePolyfill();

    let safePaypalInit = () => {
      // Putting Paypal's init in an empty timeout ensures it will fire after the current digest cycle.
      // Should resolve errors related to Paypal interruping an in progress digest cycle.
      $timeout(() => $window.paypal.checkout.initXO());
    }

    return {
      restrict: 'E',
      scope: {
        product: '&?',
        upsellId: '@?',
        originalId: '@?',
        orderId: '@?',
        size: '=?'
      },
      template: require('./paypal-payment.jade')(jadeLocals),
      transclude: true,
      link: (scope, el) => {
        scope.paypalCheckout = function paypalCheckout() {

          // if its an upsell, make sure we have a valid size.
          if (!isUpsell(scope) || (isUpsell(scope) && scope.size)) {

            if (checkoutFnInProgress) return;
            checkoutFnInProgress = true;
            let paypalPromise;

            if (!isUpsell(scope)) cart.triggerInitiateCheckout();
            analytics.checkout({ option: 'PayPal', upsell: isUpsell(scope), cart: cart.contentsAsCampaignProducts() });
            safePaypalInit();

            let slug = cart.slug().split('/'),
              publicName = slug[0],
              campaignSlug = slug[1];

            let cancelUrl = $window.location.href.split('#')[0];
            storage.setLocalItem('paypal-cancel', cancelUrl);
            if (isUpsell(scope)) {
              let callbackUrl = `https://${$window.location.host}/purchase/paypal-checkout?pn=${publicName}&sl=${campaignSlug}&upsell=true`;
              let upsellPayload = {
                product: scope.product(),
                upsellID: scope.upsellId,
                originalID: scope.originalId,
                orderID: scope.orderId
              };
              storage.removeLocalItem('paypal-upsell');
              storage.setLocalItem('paypal-upsell', JSON.stringify(upsellPayload));
              paypalPromise = cart.paypalCheckoutUpsellCart(callbackUrl, cancelUrl, scope.product(), scope.upsellId, scope.orderId);
            } else {
              let callbackUrl = `https://${$window.location.host}/purchase/paypal-checkout?pn=${publicName}&sl=${campaignSlug}`;
              paypalPromise = cart.paypalCheckoutCart(callbackUrl, cancelUrl);
            }

            paypalPromise
              .then((res) => $window.paypal.checkout.startFlow(res.url))
              .catch((res) => {
                errorHandler.throwError(`${res.status} Error`, res && res.data && res.data.message ? res.data.message : 'Occurred during paypal flow.');
                $window.paypal.checkout.closeFlow();
              })
              .finally(() => checkoutFnInProgress = false);
          };
        }
      }
    }
  }
]


// WEBPACK FOOTER //
// ./source/client/layout-components/paypal-payment/paypal-payment.dir.js